// Client-side CSV export — build a CSV from headers + rows and trigger a
// download. Used by the page kebab menus ("Export CSV").

/** Minor units → a plain 2-dp major string for CSV cells ("" when null). */
export const csvMoney = (m: number | null | undefined): string =>
  m === null || m === undefined ? "" : (m / 100).toFixed(2);

function esc(v: string | number | null | undefined): string {
  const s = v === null || v === undefined ? "" : String(v);
  return /["\n,]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function downloadCsv(
  filename: string,
  headers: string[],
  rows: (string | number | null | undefined)[][],
): void {
  const csv = [headers, ...rows].map((r) => r.map(esc).join(",")).join("\r\n");
  const blob = new Blob([`﻿${csv}`], { type: "text/csv;charset=utf-8" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
